export default class Cookies {
  static set = async (params) => {
    Cookies.doSetCookieJS({ params })

    Cookies.doSetCookiePHP({ params })
  }

  static get(key) {
    const name = key + '='
    const cookies = document.cookie.split(';')

    for (let cookie of cookies) {
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1, cookie.length)
      }

      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length)
      }
    }

    return null
  }

  static doSetCookieJS({ params }) {
    const cookie_name = params.cookie_name
    let cookie_expire = ''

    if (params.cookie_expire) {
      const date = new Date()

      date.setTime(date.getTime() + params.cookie_expire)

      cookie_expire = '; expires=" ' + date.toUTCString()
    }
  
    document.cookie = cookie_name + '=' + cookie_name + cookie_expire + '; path=/'
  }

  static doSetCookiePHP = async (params) => {
    await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: new URLSearchParams(params)
    })
    .then(response => response.text())
    .catch((error) => {
      console.error('Error:', error)
    })
  }
}
